import apiClient from './apiClient';
import { CalendarPlan, CalendarSummaryItem } from '../types';

interface GenerateCalendarPayload {
  start_date: string;
  days: number;
  constitution?: string | null;
}

export interface CreateCalendarEventPayload {
  date: string;
  title: string;
  description?: string;
  time_of_day?: string;
  category?: string;
}

export async function generateCalendarPlan(payload: GenerateCalendarPayload): Promise<CalendarPlan> {
  const response = await apiClient.post<CalendarPlan>('/calendar/generate', payload);
  return response.data;
}

export async function fetchCalendarList(params?: { year?: number }): Promise<CalendarSummaryItem[]> {
  const response = await apiClient.get<CalendarSummaryItem[]>('/calendar/list', { params });
  return response.data;
}

export async function fetchCalendarDetail(calendarId: string): Promise<CalendarPlan> {
  const response = await apiClient.get<CalendarPlan>(`/calendar/${calendarId}`);
  return response.data;
}

export async function createCalendarEvent(
  calendarId: string,
  payload: CreateCalendarEventPayload,
): Promise<CalendarPlan> {
  const response = await apiClient.post<CalendarPlan>(`/calendar/${calendarId}/events`, payload);
  return response.data;
}

export async function deleteCalendarEvent(calendarId: string, eventId: string): Promise<CalendarPlan> {
  const response = await apiClient.delete<CalendarPlan>(`/calendar/${calendarId}/events/${eventId}`);
  return response.data;
}

export async function deleteCalendarPlan(calendarId: string): Promise<void> {
  await apiClient.delete(`/calendar/${calendarId}`);
}
